module.exports = __webpack_public_path__ + "static/media/17.fdcb2ba7.jpg";